import React, { useState } from 'react';
import { Tags } from '../Tags';
import {
  IconContainer,
  InputContainer,
  LabelInputContainer,
  SearchBoxContainer,
  SearchFieldInput,
  StyledSearchFieldContainer,
  OptionItem,
  OptionList,
  TagList,
  RadioWithLabelContainer,
  RadioContainer,
  StyledTextLabel,
} from './styled.searchBox';
import { CloseCircleDark } from './../../icons/CloseCircleDark';
import { Body4, Body5 } from './../../typography';
import { SearchIcon } from '../../icons/SearchIcon';
import { ISearchBox } from '../../../@types/searchBox';
import { ErrorValidation } from './../ErrorValidation';
import { useTranslation } from 'react-i18next';
import { RadioButton } from '../RadioButton';

export function SearchBox ({
  handleInputChange,
  searchBoxOptions,
  handleOptionClick,
  clearSearch,
  selectedOptions,
  label,
  searchTextName,
  placeholderText,
  showTags = false,
  showRadioButton = false,
  removeTag,
  radioButtonCheckedType,
  handleClickRadioButton,
  isError,
  disabled = false,
}: ISearchBox) {
  const [isFocused, setIsFocused] = useState(false);
  const { t } = useTranslation();

  return (
    <SearchBoxContainer data-testid="search-box" showTags={showTags}>
      <LabelInputContainer>
        <RadioWithLabelContainer>
          <StyledTextLabel>
            {label && (
              <Body5 data-testid="search-box-label" color="eerieBlack">
                {label}
              </Body5>
            )}
          </StyledTextLabel>
          {showRadioButton && (
            <RadioContainer>
              <RadioButton
                data-testid="search-box-radio-button-and"
                checked={radioButtonCheckedType === 'and'}
                label={'And'}
                onClick={() =>
                  handleClickRadioButton && handleClickRadioButton('and')
                }
              />
              <RadioButton
                data-testid="search-box-radio-button-or"
                checked={radioButtonCheckedType === 'or'}
                label={'Or'}
                onClick={() =>
                  handleClickRadioButton && handleClickRadioButton('or')
                }
              />
            </RadioContainer>
          )}
        </RadioWithLabelContainer>
        <InputContainer>
          <StyledSearchFieldContainer isError={isError}>
            <IconContainer>
              <SearchIcon />
            </IconContainer>

            <SearchFieldInput
              onFocus={() => setIsFocused(true)}
              onBlur={() => setTimeout(() => setIsFocused(false), 100)}
              type="text"
              value={
                !showTags && selectedOptions.length === 1
                  ? selectedOptions[0].text
                  : searchTextName
              }
              placeholder={placeholderText}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(event.target.value)
              }
              disabled={disabled}
              data-testid="search-box-text-input"
            />
            {searchTextName && searchTextName.length > 0 && (
              <IconContainer
                data-testid="search-box-text-input-clear-input"
                onClick={clearSearch}
              >
                <CloseCircleDark />
              </IconContainer>
            )}
          </StyledSearchFieldContainer>
          {(showTags || selectedOptions.length === 0) &&
            searchTextName &&
            searchBoxOptions.length > 0 &&
            isFocused && (
              <OptionList data-testid="search-box-option-list">
                {searchBoxOptions.map((option) => (
                  <OptionItem
                    data-testid="search-box-option-item"
                    key={option.id}
                    onClick={() => handleOptionClick(option)}
                  >
                    <Body4 color="eerieBlack">{option.text}</Body4>
                  </OptionItem>
                ))}
              </OptionList>
            )}
          {isError && (
            <ErrorValidation
              message={t(
                'COMMON.MY_AUDIT.ASSIGN_FORM.PLEASE_SELECT_VALID_ASSIGNEE'
              )}
            />
          )}
        </InputContainer>
      </LabelInputContainer>
      {showTags && (
        <TagList data-testid="search-box-tag-list">
          {selectedOptions.map((tag, index) => (
            <Tags
              key={tag.id}
              text={tag.text}
              onDelete={() => removeTag && removeTag(index)}
              disabled={disabled}
            />
          ))}
        </TagList>
      )}
    </SearchBoxContainer>
  );
}
